import React from 'react';

const Conclusion = () => (
  <div>
    <h3>💰 Join our P2P lending community</h3>
    <p>
      Thanks for learning more about how the lendify platform works. We hope you can see the benefits
      of using our platform for your lending and borrowing needs.
    </p>
    <p>
      By joining our community, you can earn higher returns on your investments, access affordable financing
      options, and participate in transparent and secure transactions.
    </p>
    <p>
      Dont miss out on these opportunities - sign up now and start using our platform to achieve your
      financial goals.
    </p>
  </div>
);

export default Conclusion;
